import React from 'react';
import { Link } from 'react-router-dom';

export default function NoPage() {
  return (
    <main className="mc-shell" style={{ padding: '6rem 0', textAlign: 'center' }}>
      <p className="mc-eyebrow">Error 404</p>
      <h1 className="mc-display" style={{ fontSize: 'clamp(2.5rem, 8vw, 5rem)', margin: '1rem 0' }}>
        Signal lost
      </h1>
      <p style={{ color: 'var(--fg-muted)', maxWidth: '44ch', margin: '0 auto 2rem' }}>
        That page isn&apos;t on this site. It may have been renamed or moved.
      </p>
      <Link to="/" className="mc-chip" style={{ padding: '0.6rem 1.2rem', color: 'var(--accent)' }}>
        ← Back to home
      </Link>
    </main>
  );
}
